import {combineReducers} from "@reduxjs/toolkit";
import authReducer , {IAuthReducerState} from "./auth.reducer";
import metaReducer, {IMetaReducerState} from "./meta.reducer";
import userAssetsReducer, {IUserAssetsReducerState} from "./user-assets.reducer.ts";
import {IProjectCodeState, projectDataReducer} from "@/store/reducers/projectdata.reducer.ts";

export interface IRootReducerState {
    auth: IAuthReducerState,
    meta: IMetaReducerState,
    userAssets: IUserAssetsReducerState,
    projectData: IProjectCodeState
}

const rootReducer = combineReducers({
    auth: authReducer,
    meta: metaReducer,
    userAssets: userAssetsReducer,
    projectData: projectDataReducer,  // Add more reducers as needed.  // TODO: replace with actual type when data structure is known.  // Add more reducers as needed.  // TODO: replace with actual type when data structure is known.  // Add more reducers as needed.  // TODO: replace with actual type when data structure is known.  // Add more reducers as needed.  // TODO: replace with actual type when data structure is known.
});

export default rootReducer;
